<script>
import Modal from "../../theme/organisms/Modal.vue";
import BasicButton from "../../theme/atoms/BasicButton.vue";

export default {
    name: "TransferToNewDomainWidget",
    components: {
        Modal,
        BasicButton
    },
    data() {
        return {
          show: false
        }
    },
    methods: {
      closeModal() {
        this.show = false;
        localStorage.setItem('hideSwitchModalTill', new Date().getTime() + 86400000);
      },
      showModal() {
          const hideSwitchModalTill = localStorage.getItem('hideSwitchModalTill');
          if (hideSwitchModalTill && new Date().getTime() < hideSwitchModalTill) {
              return;
          }

          this.show = true;
      },
      switchToNewDomain() {
            window.location.href = '/auth/transfer';
      }
    },
    mounted() {
        this.showModal();
    }
}
</script>

<template>
   <div>
       <modal v-model="show" size="lg" :title="trans('auth.transfer.transfer_modal_title')" :closeable="false" backdrop="static">
         <div class="d-flex flex-column justify-content-center align-items-center gap-3">
             <p class="text-center title">
                 {{trans('auth.transfer.transfer_modal_description')}} <b class="text-primary">app.kidsday.com</b>
             </p>

             <div>
                 <basic-button class="btn-primary" @click="switchToNewDomain()" :text="trans('auth.transfer.transfer_modal_switch_button')"/>
                 <basic-button class="btn-text" @click="closeModal()" :text="trans('auth.transfer.transfer_modal_switch_later_button')"/>
             </div>
         </div>
       </modal>
   </div>
</template>
